$(function () {

    /**
     * PRODUCT FILTER
     */

    // Show
    $(document).on('click', '.filter__toggle', (e) => {
        e.preventDefault();
        $('.filter__field').addClass('hide');
        $(e.currentTarget).next('.filter__field').removeClass('hide');
    });

    // Hide
    $(document).mouseup((e) => {
        var container = $('.filter__item');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.find('.filter__field').addClass('hide');
        }
    });

    /**
     * FIN - PRODUCT FILTER
     */


    /**
     * PRICE RANGE
     */

    const priceRange = $('#price-range');
    const priceRangeMinimum = $('.price-minimum');
    const priceRangeMaximum = $('.price-maximum');

    priceRange.slider({
        range: true,
        min: parseInt(priceRange.attr('data-min')),
        max: parseInt(priceRange.attr('data-max')),
        values: [parseInt(priceRange.attr('data-value-min')), parseInt(priceRange.attr('data-value-max'))],
        slide: function (e, ui) {
            priceRangeMinimum.val(ui.values[0]);
            priceRangeMaximum.val(ui.values[1]);
        },
    });

    priceRangeMinimum.on('change', (e) => {
        priceRange.slider('values', 0, e.target.value);
    });

    priceRangeMaximum.on('change', (e) => {
        priceRange.slider('values', 1, e.target.value);
    });

    /**
     * FIN - PRICE RANGE
     */

});

